/**
 * * 공통으로 쓰이는 타입 모음
 */

import {
  FieldValues,
  UseFormRegister,
  FieldErrors,
  ValidationRule,
} from 'react-hook-form';

export interface SubMenuList {
  name: string;
  path: string;
  key: string;
  icon: HTMLImageElement;
  iconOn: HTMLImageElement;
}
export interface MenuList {
  name: string;
  path: string;
  key: string;
  icon: HTMLImageElement;
  iconOn: HTMLImageElement;
  subMenus?: SubMenuList;
}

export interface IModalProp {
  visible: boolean;
  setVisible: (e: any) => void;
  fetchData: () => void;
  selectProject?: SelectProjectType;
}

/// DefaultSelect 컴포넌트 쓸 때, 사용하는 드롭다운
export interface IDropListProps {
  key?: number | string;
  value: number | string;
  text: number | string;
  name?: number | string;
  is_coin?: number | undefined;
  comment?: string;
}

export interface ILocalizingList {
  code?: string;
  code_name?: string | undefined | null;
  comment?: string | undefined;
  key?: number | string | undefined;
}

export interface ILangDataList {
  lang?: string | undefined | null;
  public_name?: string | undefined;
  summary?: string | undefined;
  contents?: string | undefined;
  title?: string | undefined;
  name?: string;
  writer?: string | undefined;
  original?: string | undefined;
  code_name?: string | undefined | null;
  key?: number | string | undefined;
  category_thumbnail_id?: number;
  detail_design_id?: number;
  design_id?: number;
  category_thumbnail_url?: string;
  ifyou_banner_id?: number;
  circle_image_id?: number;
  introduce_image_id?: number;
  ifyou_image_url?: string;
  circle_image_url?: string;
  introduce_image_url?: string;
  mission_name?: string;
  mission_hint?: string;
  url_link?: string | undefined;
  ability_name?: string | undefined;
}

export interface IImagePropsList {
  key?: number | undefined;
  design_id?: string | number | undefined;
  image_url?: string | undefined;
  name?: string | undefined;
  title?: string | undefined;
  text?: string | undefined;
}

/// 배포하기
export interface IDeployProp {
  user_id: string;
  kind: string;
  reason: string;
}

// 작품 api 호출 시, 필요한 타입
export interface IProjectProps {
  key?: string;
  lang?: string;
  userId?: string | number;
  masterAuth?: string | boolean;
  projectId?: number | string;
}

export interface SelectProjectType {
  title: string;
  auth?: boolean;
}

export interface SelectBackground {
  project_id: number;
  title: string;
  bg_id: number | string;
  game_scale: number | string | undefined;
  live_pair_id: number;
  image_name: string | undefined;
  image_url: string;
}
export interface SelectMinicut {
  project_id: number;
  title: string;
  minicut_id: number | string;
  live_pair_id: number;
  thumbnail_id?: number | string;
  game_scale: number | string | undefined;
  public_name: string | undefined;
  image_name: string | undefined;
  image_url: string;
  offset_x: number;
  offset_y: number;
  is_public: number;
  appear_episode: string;
}
export interface SelectMission {
  project_id?: number | undefined;
  mission_id: number | string;
  mission_name: string;
  mission_hint: string;
  mission_type: string;
  mission_figure: number;
  mission_condition: string;
  image_name: string | undefined;
  image_url: string;
  start_date: string;
  end_date: string;
  id_condition: string | undefined;
  reward_exp: number;
  reward_currency: string;
  reward_quantity: number;
  detail_hint: number;
  is_hidden: number | string;
}

export interface IMissionProp {
  currency: string;
  quantity: number;
  key?: number | undefined;
}
export interface IHashTagProp {
  hashtag_no: number;
  hashtag_name: string;
  key?: number | undefined;
}
export interface IExpandableTable {
  expandRowByClick: boolean;
  expandIconAsCell: boolean;
  expandIconColumnIndex: number;
}

// 유저
export interface IUserProps {
  userkey: number;
  nickname: string;
  country: string;
  uid: string;
  gamebaseid: string;
  createtime: string;
  lastlogintime: string;
  gem: number;
  coin: number;
  valid: string;
}
export interface IUserInfoProps {
  storeCode?: string | undefined;
  idp: string;
  network: string;
  osCode: string;
  osVersion: string;
  clientVersion: string;
  admin: number;
}
export interface IUserActionProps {
  project_name: string;
  action_name: string;
  episode_title: string;
  action_date: string;
}
export interface IUserFreepassProps {
  project_name: string;
  freepass_name: string;
  price: number;
  purchase_date: string;
}
export interface IUserPropertyProps {
  quantity: number;
  log_type: string;
  log_code: string;
  currency: string;
  property_result: number;
  action_date: string;
  paid: string;
  project_name: string;
  currency_name: string;
  currency_type_name: string;
}
export interface IUserCouponProps {
  coupon_id: number;
  use_date: string;
  coupon_name: string;
  coupon_code: string;
  coupon_detail_list: string;
}
export interface IUserMailProps {
  mail_no: number;
  send_date: string;
  expire_date: string;
  mail_type: string;
  mail_name: string;
  currency: string;
  currency_name: string;
  quantity: number;
  reservation_no: number;
}
export interface ISearchData {
  searchType?: string;
  searchWord?: string;
  from_date?: string;
  to_date?: string;
  search_start_date?: string;
  search_end_date?: string;
  search_date_type?: string;
  search_state?: string;
  search_currency?: string[];
  search_mail_type?: string;
}

export interface IInputProps {
  register: UseFormRegister<FieldValues>;
  errors: FieldErrors<FieldValues>;
  title: string;
  name: string;
  type: string;
  errText: string;
  placeHolder: string;
  opts: {
    pattern?: {
      value: RegExp;
      message: string;
    };
    required?: string | boolean;
    maxLength?: {
      value: number;
      message: string;
    };
    minLength?: {
      value: number;
      message: string;
    };
  };
  disabled?: boolean;
}

export interface IOrganization {
  id: number;
  name: string;
  isDeleted: boolean;
}
export interface IAccount {
  id: number;
  accessToken: string;
  refreshToken: string;
  user_id: number;
  master_auth: number;
  email: string;
  userName: string;
  password: string;
  organization: IOrganization;
  role: string;
  verified: boolean;
  projectAuths: IProjectAuth[];
}

export interface IProjectAuth {
  id: number;
  project_id: number;
  auth_kind: string;
}

export enum UserRole {
  SuperAdmin = 'SuperAdmin',
  Admin = 'Admin',
  User = 'User',
}
